import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import css from '../../css/sidebar/groupList.module.scss';
import sidebarCss from '../../css/sidebar/sidebar.module.scss';
import { ReactComponent as ArrowDown } from '../../img/common/arrowDown.svg';
import { ReactComponent as ArrowRight } from '../../img/common/arrowRight.svg';
import { ChatGroup } from '../../model/chatGroup';
import { Pagination } from '../../model/pagination';
import { getRooms, selectChatGroup, selectGroup } from '../../slice/chatGroupSlice';
import { RoomList } from './roomList';

type GroupListProps = {
    group: ChatGroup & Pagination;
};

export const GroupList: React.FC<GroupListProps> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const group = props.group;
    const [isOpen, setIsOpen] = useState(false);
    const { selectedChatGroup: selectedGroup } = useSelector(selectChatGroup);
    const onCallUsersCount = props.group.chatRooms.reduce((current, r) => r.members.length + current, 0);

    const nameStyle = selectedGroup?.id === group.id ? { color: '#faf8f7', backgroundColor: '#403e3d' } : {};

    useEffect(() => {
        dispatch(getRooms(group.id));
    }, [dispatch, group.id]);

    return (
        <>
            <div className={css.name} style={nameStyle}>
                {isOpen ? (
                    <ArrowDown height="16" width="16" fill="#FAF8F7" onClick={() => setIsOpen(false)} />
                ) : (
                    <ArrowRight height="16" width="16" fill="#FAF8F7" onClick={() => setIsOpen(true)} />
                )}
                <img src={group.icon} alt="" className={css.icon} />
                <span
                    onClick={() => {
                        dispatch(selectGroup(group.id));
                        history.push(`/groups/${group.id}`);
                    }}
                >
                    {group.name}
                </span>
                {onCallUsersCount > 0 && !isOpen && (
                    <span className={sidebarCss.mark} style={{ backgroundColor: '#48d040' }}>
                        {onCallUsersCount}人
                    </span>
                )}
            </div>
            {isOpen && (
                <ul className={css.rooms}>
                    {group.chatRooms.map((room, idx) => {
                        return (
                            <li key={idx}>
                                <RoomList group={group} room={room} />
                            </li>
                        );
                    })}
                    {group.hasMore && (
                        <li className={css.more} onClick={() => dispatch(getRooms(group.id))}>
                            もっと見る
                        </li>
                    )}
                </ul>
            )}
        </>
    );
};
